// Read more/less logic for product tech details section
document.addEventListener("DOMContentLoaded", function () {
  function getWordLimit(container) {
    var desktopLimit =
      parseInt(container.getAttribute("data-desktop-word-limit"), 10) || 60;
    var mobileLimit =
      parseInt(container.getAttribute("data-mobile-word-limit"), 10) || 30;
    var isMobile = window.matchMedia("(max-width: 1024px)").matches;
    return isMobile ? mobileLimit : desktopLimit;
  }

  function truncateWords(html, wordLimit) {
    var div = document.createElement("div");
    div.innerHTML = html;
    var text = div.textContent || div.innerText || "";
    var words = text.split(/\s+/);
    if (words.length <= wordLimit) {
      return html;
    }
    // HTML-preserving truncation
    var wordCount = 0;
    function walk(node) {
      if (wordCount >= wordLimit) return "";
      if (node.nodeType === Node.TEXT_NODE) {
        var nodeWords = node.textContent.split(/\s+/);
        if (wordCount + nodeWords.length <= wordLimit) {
          wordCount += nodeWords.length;
          return node.textContent;
        } else {
          var take = wordLimit - wordCount;
          wordCount = wordLimit;
          return nodeWords.slice(0, take).join(" ") + "...";
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        var html = "<" + node.nodeName.toLowerCase();
        for (var i = 0; i < node.attributes.length; i++) {
          html +=
            " " +
            node.attributes[i].name +
            '="' +
            node.attributes[i].value +
            '"';
        }
        html += ">";
        for (var j = 0; j < node.childNodes.length; j++) {
          html += walk(node.childNodes[j]);
          if (wordCount >= wordLimit) break;
        }
        html += "</" + node.nodeName.toLowerCase() + ">";
        return html;
      }
      return "";
    }
    return walk(div);
  }

  document
    .querySelectorAll("[data-readmore-container]")
    .forEach(function (container) {
      var shortDesc = container.querySelector(".readmore-short");
      var fullDesc = container.querySelector(".readmore-full");
      var readMoreToggle = container.querySelector(".readmore-toggle");
      var readMoreSpan = readMoreToggle
        ? readMoreToggle.querySelector(".read-more")
        : null;
      var readLessSpan = readMoreToggle
        ? readMoreToggle.querySelector(".read-less")
        : null;
      if (
        !shortDesc ||
        !fullDesc ||
        !readMoreToggle ||
        !readMoreSpan ||
        !readLessSpan
      ) {
        return;
      }
      var originalHtml = fullDesc.innerHTML;
      var prevIsMobile = window.matchMedia("(max-width: 1024px)").matches;
      var updateDisplay = function () {
        var wordLimit = getWordLimit(container);
        var truncated = truncateWords(originalHtml, wordLimit);
        shortDesc.innerHTML = truncated;
        // Remove HTML tags for comparison
        var plainTruncated = truncated.replace(/<[^>]+>/g, "").trim();
        var plainOriginal = originalHtml.replace(/<[^>]+>/g, "").trim();
        if (plainTruncated === plainOriginal) {
          // All text is visible, hide read more/less
          shortDesc.style.display = "";
          fullDesc.style.display = "none";
          readMoreToggle.style.display = "none";
        } else {
          shortDesc.style.display = "";
          fullDesc.style.display = "none";
          readMoreToggle.style.display = "";
          readMoreSpan.style.display = "";
          readLessSpan.style.display = "none";
          readMoreToggle.setAttribute("aria-expanded", "false");
        }
      };
      readMoreToggle.addEventListener("click", function () {
        if (fullDesc.style.display === "none") {
          fullDesc.style.display = "block";
          shortDesc.style.display = "none";
          readMoreSpan.style.display = "none";
          readLessSpan.style.display = "";
          readMoreToggle.setAttribute("aria-expanded", "true");
        } else {
          fullDesc.style.display = "none";
          shortDesc.style.display = "";
          readMoreSpan.style.display = "";
          readLessSpan.style.display = "none";
          readMoreToggle.setAttribute("aria-expanded", "false");
        }
      });
      updateDisplay();
      window.addEventListener("resize", function () {
        var isMobile = window.matchMedia("(max-width: 1024px)").matches;
        if (isMobile !== prevIsMobile) {
          prevIsMobile = isMobile;
          updateDisplay();
        }
      });
    });
});
